<template>
    <form v-if="hasAccess" action="" method="POST" @submit.prevent="save"
          class="h-full max-w-sm mx-auto pt-2 px-4 pb-8 md:pb-4 clearfix">
        <top-nav-bar goto="/?page=support"></top-nav-bar>

        <h3 class="text-center mb-8">Submit a new support request</h3>

        <form-group v-if="type === null" label="Request Type" name="type" :required="true">
            <div class="select">
                <select v-model="type" id="request_type" class="input" name="type">
                    <option value="">Select a Request Type</option>
                    <option v-for="t in types" :value="t.value">
                        {{t.label}}
                    </option>
                </select>
            </div>
        </form-group>

        <form-group label="Subject" name="subject" help="Add a subject to your question.">
            <input id="subject" type="text" name="subject" class="input" v-model="subject">
        </form-group>

        <form-group label="Your Question" name="question" help="Please add your question here." :required="true">
            <textarea name="question" id="question" rows="10" class="input" v-model="question"></textarea>
        </form-group>

        <form-group label="File" name="file" help="If you have a PDF-file that relates to your question, please upload it here.">
            <div class="overflow-hidden relative mt-4 mb-4">
                <button type="button"
                        class="bg-blue hover:bg-blue-dark text-white font-bold py-2 px-4 w-full inline-flex items-center justify-center">
                    <svg fill="#FFF" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/>
                    </svg>
                    <span class="ml-2">Select {{file ? 'different':'a'}} file to upload</span>
                </button>
                <input class="cursor-pointer absolute block opacity-0 pin-r pin-t pin-b" type="file"
                       @change="fileChange" accept="application/pdf">
            </div>
            <div v-if="file">{{file.name}}</div>
        </form-group>

        <div class="block md:inline-flex md:float-right">
            <button class="btn btn--colored__green w-full" type="submit">
                <i class="fal fa-check"></i>
                {{saving ? 'Submitting...' : 'Submit'}}
            </button>
        </div>

    </form>
</template>

<script>
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],
        data() {
            return {
                subject: null,
                question: '',
                file: null,
                saving: false,
                types: [
                    {
                        value: 'HR',
                        label: 'HR',
                    },
                    {
                        value: 'Payroll',
                        label: 'Payroll',
                    },
                    {
                        value: 'IT',
                        label: 'IT'
                    },
                    {
                        value: 'Other',
                        label: 'Other'
                    }
                ]
            }
        },

        computed: {
            type() {
                return this.$route.params.type || null
            }
        },

        methods: {

            fileChange(e) {
                if (!e.target.files.length)
                    return;

                if (e.target.files[0].type !== 'application/pdf') {
                    this.$noty.error('The selected file is not a PDF. Please select a PDF.')
                    return;
                }

                this.file = e.target.files[0]
            },

            save() {
                this.saving = true;

                let form = new FormData(this.$el);

                form.append('type', this.type);

                if (this.file) {
                    form.append('file', this.file)
                }
                this.$api('hr', this).post('support', form)
                    .then(() => {
                        this.$noty.success('Support request submitted.')
                        this.$router.push('/')
                    })
                    .finally(() => {
                        this.saving = false
                    })
            }

        }
    }
</script>
